import React from "react";
import { useLocation } from "react-router-dom";

const OrderSummary = () => {
  const { state } = useLocation();
  const { formData, cart, totalPrice } = state || {};

  return (
    <div className="p-8 bg-gray-100 min-h-screen flex flex-col items-center">
      <h1 className="text-4xl font-extrabold text-gray-900 mb-10">Order Summary</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-6xl">
        {/* Shipping Information */}
        <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Shipping Information</h2>
          <div className="space-y-3 text-gray-700">
            <p><span className="font-semibold">Full Name:</span> {formData?.fullName}</p>
            <p><span className="font-semibold">Email:</span> {formData?.email}</p>
            <p><span className="font-semibold">Phone:</span> {formData?.phone}</p>
            <p><span className="font-semibold">Country:</span> {formData?.country}</p>
            <p><span className="font-semibold">City:</span> {formData?.city}</p>
            <p><span className="font-semibold">State:</span> {formData?.state}</p>
            <p><span className="font-semibold">ZIP Code:</span> {formData?.zip}</p>
            <p><span className="font-semibold">Shipping Method:</span> {formData?.shippingMethod}</p>
          </div>
        </div>
        
        {/* Ordered Items */}
        <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-200 col-span-2">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Ordered Items</h2>
          {cart?.length > 0 ? (
            <div className="space-y-4">
              {cart.map((item, index) => (
                <div key={index} className="flex items-center gap-4 p-4 border-b border-gray-300">
                  <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded-lg shadow-sm" />
                  <div className="flex-1">
                    <h4 className="font-semibold text-gray-900 text-lg">{item.name}</h4>
                    {item.selectedSize && <p className="text-gray-600 text-sm">Size: {item.selectedSize}</p>}
                    {item.selectedColor && <p className="text-gray-600 text-sm">Color: {item.selectedColor}</p>}
                    
                  </div>
                  <div className="font-bold text-gray-900 text-lg">${(item.price * item.quantity).toFixed(2)}</div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-gray-500">No items in the order.</p>
          )}
        </div>
      </div>

      {/* Order Total */}
      <div className="mt-8 w-full max-w-6xl">
        <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-200 text-center">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Total Amount</h2>
          <div className="flex justify-between items-center text-xl font-bold text-gray-900">
            <span>Total:</span>
            <span>${totalPrice?.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
